<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('Reports')" class="mt-2" v-if="reportsTab">
            <reports></reports>
          </vs-tab>
          <vs-tab
            :label="$t('ReportComprehensiveTaxSystemForAgents')"
            class="mt-2"
            v-if="
              $tabHasPermission(
                'GetExcelOfSaleAgentOrderForReportOfSamanehJame'
              )
            "
          >
            <report-comprehensive-tax-system-agents></report-comprehensive-tax-system-agents>
          </vs-tab>
          <vs-tab
            :label="$t('ReportComprehensiveTaxSystemForCustomers')"
            class="mt-2"
            v-if="
              $tabHasPermission(
                'GetExcelOfBusinessToCustomerOrderForReportOfSamanehJame'
              )
            "
          >
            <report-comprehensive-tax-system-customers></report-comprehensive-tax-system-customers>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Reports from "./Reports.vue";
import ReportComprehensiveTaxSystemAgents from "./ReportComprehensiveTaxSystemAgents.vue";
import ReportComprehensiveTaxSystemCustomers from "./ReportComprehensiveTaxSystemCustomers.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_DraftOrders_Index",
  components: {
    Reports,
    ReportComprehensiveTaxSystemCustomers,
    ReportComprehensiveTaxSystemAgents,
  },
  data() {
    return {
      reportsTab: true,
    };
  },
};
</script>
